module.exports = __webpack_public_path__ + "img/sapphireAndRubin.445277e.webp";